/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsgross1Inputs */

const en_earningsgross1 = /** @type {(inputs: Earningsgross1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenue`)
};

const de_earningsgross1 = /** @type {(inputs: Earningsgross1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz`)
};

/**
* | output |
* | --- |
* | "Revenue" |
*
* @param {Earningsgross1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsgross1 = /** @type {((inputs?: Earningsgross1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsgross1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsgross1(inputs)
	return de_earningsgross1(inputs)
});
export { earningsgross1 as "earningsGross" }